import type { DataGridContextMenuProps } from "src/components/DataGrid/useDataGridRowContextMenu.tsx";
import { useDataRouterContext } from "src/lib/react-router/useDataRouterContext.ts";
import { getOwnerProfilesListPath } from "src/admin/modules/owner-profile/utils.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const useOwnerListContextMenu = (): {
  items: DataGridContextMenuProps["items"];
  isPending: boolean;
} => {
  const { router } = useDataRouterContext();
  const { t } = useTranslation(TranslationNamespaceEnum.Common);
  return {
    isPending: false,
    items: [
      {
        key: "view-profiles",
        label: t("actions.viewProfiles"),
        icon: <span className={"icon-20-custmr_prfl"} />,
        onSelect: (row) => {
          router.navigate(getOwnerProfilesListPath(row.id));
        },
      },
    ],
  };
};
